var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"slot":"no-body"},slot:"no-body"},[_c('vue-apex-charts',{attrs:{"type":"donut","width":350,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }